import gql from 'graphql-tag';
import type { MutationResult } from '@apollo/client';

// STL-2226: claimHome is coupled with saveHome to ensure that users
// are able to see this home in their saved homes & receive corresponding
// home report emails
export const claimHomeMutation = gql`
    mutation ClaimHome(
        $zpid: ID!
        $propertyClaimType: PropertyClaimType!
        $propertyClaimSourceType: PropertyClaimSourceType!
    ) {
        claimHome(
            zpid: $zpid
            propertyClaimType: $propertyClaimType
            propertyClaimSourceType: $propertyClaimSourceType
        ) {
            success
            error
        }
        saveHome(zpid: $zpid)
    }
`;

export const claimHome = async (apolloClient, zpid, propertyClaimSourceType) =>
    (await apolloClient.mutate({
        mutation: claimHomeMutation,
        variables: {
            propertyClaimSourceType,
            propertyClaimType: 'OWNERSHIP',
            zpid,
        },
    })) as MutationResult;
